<div class="protocol-viewer-container">
  <abc-splitter
    #categorySplitter
    [orientation]="'right'"
    [removeTransforms]="true"
    [ngStyle]="{
      minWidth: UiSettings.categoryListMinWith + 'px',
      width: '300px'
    }"
  >
    <protocol-category-list
      #categoryListComponent
      [categoryDescription]="categoryDescriptionInfo"
    ></protocol-category-list>
  </abc-splitter>
  <protocol-category-view
    #categoryViewComponent
    [ngStyle]="{
      width: 'calc(100% - ' + (categorySplitter?.width ?? UiSettings.categoryListMinWith) + 'px)',
      minWidth: UiSettings.viewMinWidth + 'px'
    }"
    class="view"
  ></protocol-category-view>
</div>
